module.exports = __webpack_public_path__ + "static/img/nanjing0.3283220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nanjing0.png
// module id = 6L6Q
// module chunks = 1